import {useQuery} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    GetActivityDefaults as GetActivityDefaultsQuery,
    GetActivityDefaultsVariables as GetActivityDefaultsVariables,
    GetActivityDefaults_activityDefaults as ActivityDefaults,
} from 'nutshell-graphql-types';

import GET_ACTIVITY_DEFAULTS from '../queries/get-activity-defaults.graphql';

export const useGetActivityDefaults = (
    relatedEntityId: string,
    skip: boolean,
    input: {
        activityTypeId: string | null | undefined;
        durationMinutes: number | null | undefined;
        note: string | null | undefined;
    }
): {
    activityDefaults: ActivityDefaults | null | undefined;
    isLoading: boolean;
    error: string | null | undefined;
    refetch: () => Promise<any>;
} => {
    const {loading, data, error, refetch} = useQuery<
        GetActivityDefaultsQuery,
        GetActivityDefaultsVariables
    >(GET_ACTIVITY_DEFAULTS, {
        variables: {
            input: {
                relatedEntityId,
                ...input,
            },
        },
        fetchPolicy: 'cache-and-network',
        skip,
    });

    const activityDefaults = data ? data.activityDefaults : null;

    return {
        activityDefaults,
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
        refetch,
    };
};
